import axios from "axios";

const API_URL = "https://api.thunderbirdsmoke.net/api/delivery-zones"; // ✅ backend route for zones

// ✅ Helper for auth header
const authHeader = () => {
  const token = localStorage.getItem("authToken") || localStorage.getItem("token"); // check both
  if (!token) throw new Error("No auth token found");
  return { Authorization: `Bearer ${token}` };
};

// ✅ Fetch all delivery zones
export const getDeliveryZones = async () => {
  const res = await axios.get(API_URL, { headers: authHeader() });
  return res.data;
};

// ✅ Create a new delivery zone (city-based)
export const createDeliveryZone = async (zone: {
  name: string;
  city: string;
  fee_cents: number;
  active: boolean;
}) => {
  const res = await axios.post(API_URL, zone, { headers: authHeader() });
  return res.data;
};

// ✅ Update an existing delivery zone
export const updateDeliveryZone = async (id: number, zone: any) => {
  const res = await axios.put(`${API_URL}/${id}`, zone, { headers: authHeader() });
  return res.data;
};

// ✅ Delete a delivery zone
export const deleteDeliveryZone = async (id: number) => {
  const res = await axios.delete(`${API_URL}/${id}`, { headers: authHeader() });
  return res.data;
};
